import { render, staticRenderFns } from "./ForgetBox.vue?vue&type=template&id=04d8b66f&scoped=true&"
import script from "./ForgetBox.vue?vue&type=script&lang=js&"
export * from "./ForgetBox.vue?vue&type=script&lang=js&"
import style0 from "./ForgetBox.vue?vue&type=style&index=0&id=04d8b66f&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04d8b66f",
  null
  
)

export default component.exports